// extracted by mini-css-extract-plugin
export default {"noContent":"ProjectList_noContent__xyNV5"};